import { randomRange } from "../../../common/common_funcs.js";
import { Game } from "../../../game.js";
import { VfxConfettiBatch } from "./vfx_confetti_batch.js";

export class VfxConfettiBottom
{
  public static readonly PARTICLES_PER_BURST : number = 210; // 70 particles per cannon

  public static readonly MIN_LIFESPAN        : number = 2800;
  public static readonly MAX_LIFESPAN        : number = 3500;
  public static readonly MIN_START_DELAY     : number = 0;
  public static readonly MAX_START_DELAY     : number = 180;

  // Angles for 3 bottom cannons (in degrees)
  public static readonly MIN_DEG_LEFT        : number = 60;
  public static readonly MAX_DEG_LEFT        : number = 82;

  public static readonly MIN_DEG_CENTER      : number = 75;
  public static readonly MAX_DEG_CENTER      : number = 105;

  public static readonly MIN_DEG_RIGHT       : number = 98;
  public static readonly MAX_DEG_RIGHT       : number = 120;

  public static readonly MIN_SPEED           : number = 3;
  public static readonly MAX_SPEED           : number = 5;
  public static readonly MIN_SPIN            : number = -0.006;
  public static readonly MAX_SPIN            : number = 0.006;

  public static readonly MIN_FLUTTER_AMP     : number = 40;
  public static readonly MAX_FLUTTER_AMP     : number = 50;
  public static readonly MIN_FLUTTER_FREQ    : number = 0.002;
  public static readonly MAX_FLUTTER_FREQ    : number = 0.003;

  public static readonly COLOR_PALETTE: ReadonlyArray<[number, number, number]> = [
    [ 1.0, 0.18, 0.24 ], [ 1.0, 0.58, 0.06 ], [ 1.0, 0.9, 0.08 ], [ 0.12, 0.9, 0.36 ],
    [ 0.0, 0.78, 1.0 ], [ 0.38, 0.42, 1.0 ], [ 0.84, 0.24, 1.0 ], [ 1.0, 0.12, 0.72 ],
    [ 1.0, 0.84, 0.0 ], [ 0.2, 1.0, 0.8 ],
  ];

  public static burst( batch: VfxConfettiBatch, start_time: number ): void
  {
    const scale = LayoutScaler.getScale();
    const screen_w = Game.getScreenWidth();
    const screen_h = Game.getScreenHeight();

    const cannon_x_ratios = [ 0.20, 0.50, 0.80 ];

    for ( let i = 0; i < VfxConfettiBottom.PARTICLES_PER_BURST; i++ )
    {
      const cannon_index = i % 3;
      const cannon_base_x = screen_w * cannon_x_ratios[cannon_index];
      
      const spawn_x = cannon_base_x + randomRange( -25, 25 ) * scale;
      const spawn_y = screen_h + randomRange( 0, 20 ) * scale;

      let min_deg: number;
      let max_deg: number;

      if ( cannon_index === 0 )
      {
        min_deg = VfxConfettiBottom.MIN_DEG_LEFT;
        max_deg = VfxConfettiBottom.MAX_DEG_LEFT;
      }
      else if ( cannon_index === 1 )
      {
        min_deg = VfxConfettiBottom.MIN_DEG_CENTER;
        max_deg = VfxConfettiBottom.MAX_DEG_CENTER;
      }
      else
      {
        min_deg = VfxConfettiBottom.MIN_DEG_RIGHT;
        max_deg = VfxConfettiBottom.MAX_DEG_RIGHT;
      }

      const lifespan = randomRange( VfxConfettiBottom.MIN_LIFESPAN, VfxConfettiBottom.MAX_LIFESPAN );
      const p_start_time = start_time + randomRange( VfxConfettiBottom.MIN_START_DELAY, VfxConfettiBottom.MAX_START_DELAY );

      const launch_angle = randomRange( min_deg, max_deg ) * Math.PI / 180;
      const speed = randomRange( VfxConfettiBottom.MIN_SPEED, VfxConfettiBottom.MAX_SPEED ) * scale;

      const vel_x = Math.cos( launch_angle ) * speed;
      const vel_y = -Math.sin( launch_angle ) * speed;

      const color_rgb = VfxConfettiBottom.COLOR_PALETTE[
        Math.floor( randomRange( 0, VfxConfettiBottom.COLOR_PALETTE.length ) )
      ];

      const angle = randomRange( 0, Math.PI * 2 );
      const spin = randomRange( VfxConfettiBottom.MIN_SPIN, VfxConfettiBottom.MAX_SPIN );
      const frame_index = Math.floor( randomRange( 0, VfxConfettiBatch.ATLAS_COLS * VfxConfettiBatch.ATLAS_ROWS ) );
      const flutter_phase = randomRange( 0, Math.PI * 2 );
      const flutter_amp = randomRange( VfxConfettiBottom.MIN_FLUTTER_AMP, VfxConfettiBottom.MAX_FLUTTER_AMP );
      const flutter_freq = randomRange( VfxConfettiBottom.MIN_FLUTTER_FREQ, VfxConfettiBottom.MAX_FLUTTER_FREQ );

      batch.spawn(
        spawn_x, spawn_y, vel_x, vel_y,
        color_rgb[0], color_rgb[1], color_rgb[2],
        angle, spin, frame_index,
        lifespan, p_start_time,
        flutter_phase, flutter_amp, flutter_freq
      );
    }
  }
}
